(function () {
  function hasAudioSubmission(form) {
    const fieldset = form.querySelector('[data-clia-custom-audio]');
    if (!fieldset) return true;

    const file = fieldset.querySelector('.clia-audio-upload__file');
    const link = fieldset.querySelector('.clia-audio-upload__link');
    const uploadLiftInputs = document.querySelectorAll(
      'input[type="file"], input[name*="upload" i], input[name*="audio" i], textarea[name*="timestamp" i]'
    );

    if (file && file.files && file.files.length > 0) return true;
    if (link && link.value.trim().length > 0) return true;

    return Array.from(uploadLiftInputs).some((input) => {
      if (input === file || input === link) return false;
      if (input.type === 'file') return input.files && input.files.length > 0;
      return typeof input.value === 'string' && input.value.trim().length > 0;
    });
  }

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('[data-type="add-to-cart-form"]')) return;
      if (hasAudioSubmission(form)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const fieldset = form.querySelector('[data-clia-custom-audio]');
      const error = fieldset && fieldset.querySelector('.clia-audio-upload__error');
      const firstInput = fieldset && fieldset.querySelector('input, textarea');
      if (error) error.hidden = false;
      if (fieldset) fieldset.classList.add('clia-audio-upload--invalid');
      if (firstInput) firstInput.focus({ preventScroll: true });
      if (fieldset) fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
    true
  );

  document.addEventListener('input', function (event) {
    const fieldset = event.target.closest && event.target.closest('[data-clia-custom-audio]');
    if (!fieldset) return;
    fieldset.classList.remove('clia-audio-upload--invalid');
    const error = fieldset.querySelector('.clia-audio-upload__error');
    if (error) error.hidden = true;
  });
})();
